module.exports = __webpack_public_path__ + "img/circle-girl.fc247ba2.png";